import { render, staticRenderFns } from "./fileModule.vue?vue&type=template&id=0b2283f5&scoped=true&"
import script from "./fileModule.vue?vue&type=script&lang=js&"
export * from "./fileModule.vue?vue&type=script&lang=js&"
import style0 from "./fileModule.vue?vue&type=style&index=0&id=0b2283f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2283f5",
  null
  
)

export default component.exports